export default "__VITE_ASSET__CPEWmVyu__"